
export const environment = {
  production: false,
  existingCaseWorthyAPIURL:
  "https://uat.step.caseworthy.net/CaseWorthy.API/",
nextGenAccountsAPIURL: "https://api.uat.step.caseworthy.net/account/services/v1/",
nextGenFormsAPIURL: "https://api.uat.step.caseworthy.net/forms/services/v1/",
nextGenQueryAPIURL: "https://api.uat.step.caseworthy.net/query-apbuilder/services/v1/",
nextGenServerUrl: "https://api.uat.step.caseworthy.net/",
};
